<template>
    <OverlayLoader :isLoading="!webshopLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('clients.webshops.edit')"
                />

                <form @submit.prevent="submitForm" method="POST">
                    <h4>{{ t('general.webshop') }}</h4>

                    <Select
                        id="type"
                        :value="webshop.type"
                        name="type"
                        @change="webshop.type = $event"
                        :options="typeOptions"
                        :label="$translate.text('general.webshop_type')"
                        :disabled="true"
                    />

                    <TextInput
                        id="name"
                        :value="webshop.name"
                        name="name"
                        @change="webshop.name = $event"
                        :label="$translate.text('general.name')"
                    />

                    <h4>{{ t('clients.webshops.api_settings') }}</h4>

                    <TextInput
                        id="credentialsHost"
                        :value="webshop.credentials.host"
                        name="credentialsHost"
                        @change="webshop.credentials.host = $event"
                        :label="$translate.text('clients.webshops.host')"
                    />

                    <TextInput
                        v-if="webshop.type === 'WooCommerce'"
                        id="credentialsUsername"
                        :value="webshop.credentials.username"
                        name="credentialsUsername"
                        @change="webshop.credentials.username = $event"
                        :label="$translate.text('clients.webshops.consumer_key')"
                    />

                    <TextInput
                        v-else
                        id="credentialsUsername"
                        :value="webshop.credentials.username"
                        name="credentialsUsername"
                        @change="webshop.credentials.username = $event"
                        :label="$translate.text('clients.webshops.username')"
                    />

                    <TextInput
                        v-if="webshop.type === 'WooCommerce'"
                        id="credentialsPassword"
                        :value="webshop.credentials.password"
                        name="credentialsPassword"
                        @change="webshop.credentials.password = $event"
                        :label="$translate.text('clients.webshops.consumer_secret')"
                    />

                    <TextInput
                        v-else
                        id="credentialsPassword"
                        :value="webshop.credentials.password"
                        name="credentialsPassword"
                        @change="webshop.credentials.password = $event"
                        :label="$translate.text('clients.webshops.password')"
                    />

                    <h4>{{ t('clients.webshops.sync_settings') }}</h4>

                    <Select
                        id="comparePrices"
                        :value="webshop.settings.compare_prices"
                        name="comparePrices"
                        @change="webshop.settings.compare_prices = $event"
                        :options="comparePricesOptions"
                        :label="$translate.text('clients.webshops.compare_prices')"
                    />

                    <div class="form-group" v-if="webshop.settings.compare_prices === 1 || webshop.settings.compare_prices === '1'">
                        <div class="info-bar">
                            {{ t('clients.webshops.infobar.compare_prices')}}
                        </div>
                    </div>

                    <FormSubmit
                        :routeAfterCancelLink="{ name: 'Clients Webshops' }"
                        :buttonLabel="submittingIsLoading ? $translate.text('general.save_changes.saving') :  $translate.text('general.save_changes')"
                        :disabled="submittingIsLoading"
                    />
                </form>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import { put, get } from '@/helpers/http';
import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import TextInput from '@/components/Inputs/TextInput';
import Select from '@/components/Inputs/Select';
import FormSubmit from '@/components/Forms/FormSubmit';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';

export default {
    name: 'ClientWebshopEdit',

    components: {
        PageHeader,
        TextInput,
        Select,
        FormSubmit,
        OverlayLoader,
    },

    data() {
        return {
            webshop: {
                name: '',
                type: null,
                credentials: {
                    host: '',
                    username: '',
                    password: '',
                },
                settings: {
                    compare_prices: 0,
                },
            },

            typeOptions: [
                { label: this.$translate.text('general.select_option'), value: null },
                // { label: 'Magento', value: 'Magento' },
                // { label: 'Shopware 5', value: 'Shopware5' },
                // { label: 'Shopware 6', value: 'Shopware6' },
                { label: 'WooCommerce', value: 'WooCommerce' },
            ],

            comparePricesOptions: [
                { label: this.$translate.text('general.no'), value: 0 },
                { label: this.$translate.text('general.yes'), value: 1 },
            ],

            submittingIsLoading: false,
            webshopLoaded: false,
        };
    },

    created() {
        this.getWebshop();
    },

    methods: {
        getWebshop() {
            get({
                url: `${this.$API_URL}/api/clients/webshops/${this.$route.params.id}`,
            })
                .then((response) => {
                    this.webshop = response.data.data;
                    this.webshopLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        submitForm() {
            this.submittingIsLoading = true;

            put({
                url: `${this.$API_URL}/api/clients/webshops/${this.webshop.id}`,
                data: {
                    ...this.webshop,
                },
            })
                .then(() => {
                    this.submittingIsLoading = false;
                    this.$router.push({ name: 'Clients Webshops' });
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>

    .form-group {
        display: flex;
        align-items: center;

        .info-bar {
            margin-left: 270px;
            background: rgba($blue, .1);
            border: 1px solid $blue;
            padding: 10px;
            font-size: $font-size-base * 0.8;
            border-radius: 5px;
            width: 100%;
        }
    }

</style>
